<div class="filterOpenBtnWrapper">
  <button filterButtonEvaluationColor [isFilterValued]="!!(filterEvaluated)" class="filterOpenBtn" mat-mini-fab
    color="basic" aria-label="Apertura del filtro per la board" [matMenuTriggerFor]="filterDropdown">
    <mat-icon>filter_alt</mat-icon>
  </button>

  <div *ngIf="true" class="filterCancelBtn" (click)="onResetFilterClick()">
    cancella <mat-icon>close</mat-icon>
  </div>

</div>

<mat-menu #filterDropdown="matMenu" xPosition="before">
  <div (click)="$event.stopPropagation()">

    <ng-content></ng-content>

  </div>
  <div class="clearFilterBtnWrap">
    <button mat-flat-button color="accent" (click)="onResetFilterClick()" class="btn"
      [disabled]="!(shouldShowResetButton$ | async)">
      <mat-icon>filter_alt_off</mat-icon>
      {{'dashboard.agentManager.filter.clearFilter'| translate}}
    </button>
    &nbsp;
    <button mat-stroked-button color="basic" class="btn">
      <mat-icon>close</mat-icon>
      {{'dashboard.agentSupervisor.filter.closeFilter'| translate}}
    </button>
  </div>
</mat-menu>
